import { parrotApi } from '@libs/openapi';
import { useEffect, useState } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import { useRefreshTime } from './use-refresh';

export const useVaultTvl = () => {
  const { refreshTime } = useRefreshTime();
  const [tvl, setTvl] = useState<OpenapiClientParrotVault.GetVaultStatsChartTvlResponse>();

  const getVaultTvl = async () => {
    const result = await parrotApi.get('/vault/stats/chart/tvl', {});
    setTvl(result);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = () => {
      getVaultTvl();
      timer = setTimeout(() => {
        loop();
      }, 60 * 1000);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, [refreshTime]);

  return {
    tvl,
  };
};
